import StandardLayoutRouter from '../pages/standard-layout/standard-layout.router';



function App() {

  return (
    <StandardLayoutRouter></StandardLayoutRouter>
  );
}

export default App;